export default {
  "accessRanking.title": "アクセスランキング",
} as const;
